<div class="page-holding"></div>

<div class="choose-page">
  <section class="choose-hero">
    <div class="choose-hero__eyebrow">Why Choose Us</div>
    <h1>不是只提供软件，而是尽量把流程和结果一起做好</h1>
    <p>
      对企业来说，真正有价值的软件不只是功能数量，而是能否帮助团队更快进入使用状态、
      更稳定完成输出、并在后续协作中持续降低返工与沟通成本。
    </p>
  </section>

  <section class="choose-section">
    <div class="section-heading">
      <span>选择理由</span>
      <h2>我们更重视产品是否真的适合生产场景</h2>
    </div>

    <div class="reason-grid">
      <article class="reason-card" *ngFor="let item of reasons">
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </article>
    </div>
  </section>

  <section class="choose-section choose-section--contrast">
    <div class="section-heading">
      <span>差异点</span>
      <h2>从理解、试用到长期合作，尽量减少体验断层</h2>
    </div>

    <div class="comparison-table">
      <div class="comparison-table__head">评估维度</div>
      <div class="comparison-table__head">华瀚方式</div>
      <div class="comparison-table__head">常见问题</div>

      <ng-container *ngFor="let item of comparisonItems">
        <div class="comparison-table__label">{{ item.title }}</div>
        <div class="comparison-table__cell comparison-table__cell--positive">{{ item.ours }}</div>
        <div class="comparison-table__cell">{{ item.others }}</div>
      </ng-container>
    </div>
  </section>

  <section class="choose-section choose-section--principles">
    <div class="section-heading">
      <span>合作原则</span>
      <h2>我们希望建立的是长期可持续的协作关系</h2>
    </div>

    <div class="pillar-panel">
      <ul>
        <li *ngFor="let item of pillars">{{ item }}</li>
      </ul>
    </div>
  </section>

  <section class="choose-cta">
    <div>
      <span>下一步</span>
      <h2>如果你正在比较不同方案，欢迎直接把场景告诉我们</h2>
      <p>我们可以基于你的业务类型、流程需求和当前软件环境，给出更具体的建议。</p>
    </div>
    <div class="choose-cta__actions">
      <a routerLink="/contact" class="primary-link">联系咨询</a>
      <a routerLink="/porcelain" class="secondary-link">查看产品</a>
    </div>
  </section>
</div>
